export enum Navigate {
  About = 'about',
  Locations = 'locations',
  Services = 'services',
  Partners = 'partners',
}
